<template>
  <BreadCrumb PageTitle="Validation des Dossiers" />
  <SuperviseurValidation />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import SuperviseurValidation from "../../components/Superviseur/SuperviseurValidation.vue";

export default defineComponent({
  name: "SuperviseurValidationPage",
  components: {
    BreadCrumb,
    SuperviseurValidation,
  },
});
</script>